import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      display="flex"
      justifyContent="center"
      component="footer"
      py={2}
      pb={0}
    >
      <VuiTypography
        variant="button"
        sx={{ fontWeight: "400 !important" }}
        color="text"
      >
        © {new Date().getFullYear()} Sorgu Paneli
      </VuiTypography>
    </VuiBox>
  );
}

export default Footer;
